import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetFolderAssetForExportLocationQueryVariables = Types.Exact<{
  folderId: Types.Scalars['ID']['input'];
}>;


export type GetFolderAssetForExportLocationQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, asset?: { __typename?: 'AudioAsset', id: string, name: string } | { __typename?: 'DocumentAsset', id: string, name: string } | { __typename?: 'FileAsset', id: string, name: string } | { __typename?: 'FolderAsset', id: string, name: string } | { __typename?: 'ImageAsset', id: string, name: string } | { __typename?: 'InteractiveAsset', id: string, name: string } | { __typename?: 'InteractiveLiveAsset', id: string, name: string } | { __typename?: 'ModelAsset', id: string, name: string } | { __typename?: 'UnsupportedAsset', id: string, name: string } | { __typename?: 'VersionStackAsset', id: string, name: string } | { __typename?: 'VideoAsset', id: string, name: string } | null } | null };


export const GetFolderAssetForExportLocation = /*#__PURE__*/ gql`
    query GetFolderAssetForExportLocation($folderId: ID!) {
  account(by: {assetId: $folderId}) {
    id
    asset(id: $folderId) {
      id
      name
    }
  }
}
    ` as unknown as DocumentNode<GetFolderAssetForExportLocationQuery, GetFolderAssetForExportLocationQueryVariables>;

          

          export const useGetFolderAssetForExportLocationQuery = (options?:QueryHookOptions<GetFolderAssetForExportLocationQuery, GetFolderAssetForExportLocationQueryVariables>) => useQuery(GetFolderAssetForExportLocation, options);

          

          export type GetFolderAssetForExportLocationQueryOptions = QueryHookOptions<GetFolderAssetForExportLocationQuery, GetFolderAssetForExportLocationQueryVariables>;

          

          export const useGetFolderAssetForExportLocationLazyQuery = (options?:LazyQueryHookOptions<GetFolderAssetForExportLocationQuery, GetFolderAssetForExportLocationQueryVariables>) => useLazyQuery(GetFolderAssetForExportLocation, options);

          

          export type GetFolderAssetForExportLocationQueryResult = ReturnType<typeof useGetFolderAssetForExportLocationQuery>;

          
